module.exports = __webpack_public_path__ + "static/unity_img_3-08f043ac24e1d83109129d23349194da.png";